export const ITALIEN_MENU = {
    section1: [
        {
            name: 'House Salad',
            correct: true,
            message: ['A salad is always a great choice! You may want to ask for dressing on the side and be careful not to use too much.']
        },
        {
            name: 'Bread Sticks',
            correct: true,
            message: [
                `If you want to have a breadstick, that's fine as long as you follow the plate method for the rest of your meal.`,
                `Limit it to one breadstick and ask if they have a whole grain option.`,
            ]
        },
        {
            name: 'Garlic Bread',
            correct: true,
            message: [
                `A slice of garlic bread is fine as long as you limit it to one slice and follow the plate method.`,
                `Ask your server if there's a whole grain option for the bread.`,
            ]
        },
        {
            name: 'Provolone Sticks',
            correct: false,
            message: [
                `You should avoid anything that's breaded and fried. Please make a different selection from the list of Starters.`,
            ]
        },
        {
            name: 'Fried Zucchini',
            correct: false,
            message: [
                `While it may seem like you're making a good choice since zucchini is a non-starchy vegetable, you should always avoid anything that's been breaded and fried.`,
                `If you really want zucchini, try asking your server if it's possible to get lightly seasoned zucchini on the side without the breading. Please make a different selection from the list of Starters.`
            ]
        },
    ],
    section2: [
        {
            name: `Pizza by the Slice`,
            correct: true,
            message: [
                `If you're having pizza, limit it to 1 large slice or 2 small slices.`,
                `When it comes to toppings, skip the extra cheese and opt for veggie toppings as opposed to meats as those are high in sodium.`
            ]
        },
        {
            name: `14" Small Pizza`,
            correct: true,
            message: [
                `If you're having pizza, limit it to 1 large slice or 2 small slices.`,
                `When it comes to toppings, skip the extra cheese and opt for veggie toppings as opposed to meats as those are high in sodium.`,
                `Since you selected a whole pizza, make sure you follow the guidelines we just mentioned and share the rest with someone or save it later for leftovers.`
            ]
        },
        {
            name: `16" Medium Pizza`,
            correct: false,
            message: [
                `While having a slice of pizza is fine, try not to tempt yourself by ordering a pizza that would encourage you to eat more than you should.`,
                `Please make a different selection from the Pizza section.`
            ]
        },
        {
            name: `18" Medium Pizza`,
            correct: false,
            message: [
                `If you're having pizza, limit it to 1 large slice or 2 small slices.`,
                `When it comes to toppings, skip the extra cheese and opt for veggie toppings as opposed to meats as those are high in sodium.`
            ]
        },
        {
            name: `20" X-Large Pizza`,
            correct: false,
            message: [
                `While having a slice of pizza is fine, try not to tempt yourself by ordering a pizza that would encourage you to eat more than you should. Please make a different selection from the Pizza section.`,
            ]
        }
    ],
    section3: [
        {
            name: `Chicken Alfredo`,
            correct: false,
            message: [
                `While this dish does typically use grilled chicken rather than something breaded and fried, all the carbs from the noodles makes for a less than ideal choice.`,
                `Even with whole grain pasta, the alfredo sauce makes for a heavy meal. Please make a different selection from the Pasta section.`
            ]
        },
        {
            name: `Classic Spaghetti`,
            correct: true,
            message: [
                `Of the options here, having spaghetti with a marinara sauce is one of the better choices.`,
                `Ask for whole grain pasta if possible and follow the plate method guidelines of only eating an amount of pasta that's a quarter of your plate.`
            ]
        },
        {
            name: `Spaghetti with Meatballs`,
            correct: true,
            message: [
                `Of the options here, having spaghetti with a marinara sauce and meatballs is one of the better choices.`,
                `Ask for whole grain pasta if possible and follow the plate method guidelines of only eating an amount of pasta that's a quarter of your plate.`
            ]
        },
        {
            name: `Fettuccine Alfredo`,
            correct: false,
            message: [
                `Alfredo sauce and white sauce on pasta in general makes for a heavy meal that's hard on your body to digest.`,
                `Please make a different selection from the Pasta section.`
            ]
        },
        {
            name: `Chicken Parmesan Pasta`,
            correct: false,
            message: [
                `As always, choosing a food option that contains breaded, fried chicken is a poor choice.`,
                `If you intend on ordering this, try asking to substitute grilled chicken and whole grain pasta, and remember to follow the plate method guidelines. However, for this activity, please make a different selection from the Pasta section.`
            ]
        }
    ],
    section4: [
        {
            name: `Classic Italian`,
            correct: false,
            message: [
                `You definitely want to avoid sandwiches like a classic Italian variety because of the amount of sodium in the meats used.`,
                `Please make a different selection from the Sandwiches section.`
            ]
        },
        {
            name: `Chicken Parmesan`,
            correct: false,
            message: [
                `You should always avoid anything you know will be breaded and fried, such as chicken parm.`,
                `Please make a different selection from the Sandwiches section.`
            ]
        },
        {
            name: `Meatball and Marinara`,
            correct: true,
            message: [
                `Sandwiches can be tricky when it comes to meeting the plate method guidelines.`,
                `You should limit the amount you eat, like only eating half of a 6' sandwich. Opting for whole grain bread and eating it open-faced are great ways to improve this choice.`
            ]
        },
        {
            name: `Tuna Melt`,
            correct: true,
            message: [
                `Sandwiches can be tricky when it comes to meeting the plate method guidelines.`,
                `You should limit the amount you eat, like only eating half of a 6' sandwich. Opting for whole grain bread and eating it open-faced are great ways to improve this choice.`
            ]
        },
        {
            name: `Mediterranean Veggie`,
            correct: true,
            message: [
                `Sandwiches can be tricky when it comes to meeting the plate method guidelines.`,
                `You should limit the amount you eat, like only eating half of a 6' sandwich. Opting for whole grain bread and eating it open-faced are great ways to improve this choice.`
            ]
        }
    ],
    section5: [
        {
            name: `French Fries`,
            correct: false,
            message: [
                `While having french fries isn't necessarily the worst choice, out of the options presented here it would be better to choose the sweet potato fries instead for their additional nutrients. Please make a different selection.`,            ]
        },
        {
            name: `Sweet Potato Fries`,
            correct: true,
            message: [
                `As with the plate method when cooking at home, make sure to limit sweet potato fries and eat no more than a quarter of your plate.`,
            ]
        },
        {
            name: `Steamed Broccoli`,
            correct: true,
            message: [
                `Having broccoli on the side with your meal is always a great choice.`,
                `While it's recommended to fill half the plate, we understand that's not always possible at a restaurant. Great choice!`
            ]
        },
        {
            name: `Mac and Cheese`,
            correct: false,
            message: [
                `Mac and cheese is a comfort food that many people love, but all that cheese on top of the carbs from the macaroni noodles is going to spell trouble.`,
                `Please make a different selection.`
            ]
        },
        {
            name: `Side Salad`,
            correct: true,
            message: [
                `A salad is always a perfect choice, even just as a side with your entree!`,
                `You may want to ask for dressing on the side and be careful not to use too much.`
            ]
        }
    ],
    section6: [
        {
            name: `Regular Soda`,
            correct: false,
            message: [
                `Just as with the plating method at home, you want to avoid regular soda due to the sugar content.`,
                `Opt for a sugar-free or diet option instead. Please make a different Drink selection.`
            ]
        },
        {
            name: `Diet Soda`,
            correct: true,
            message: [
                `While not as beneficial as milk or water, diet or sugar free soda is an okay choice.`,
            ]
        },
        {
            name: `Sweet Tea`,
            correct: false,
            message: [
                `Tea may seem like it's better than regular soda, but with sweet tea you're often getting a lot more added sugar than you really should.`,
                `Opt for unsweetened instead if you're having tea. Please make a different Drink selection.`
            ]
        },
        {
            name: `Iced Tea`,
            correct: true,
            message: [
                `Iced tea is a fine choice as long as it's unsweetened.`,
                `If you prefer to have your tea with some sweetness, ask for a sugar substitute when you order.`
            ]
        },
        {
            name: `Water`,
            correct: true,
            message: [
                `Water is a no-brainer when it comes to keeping your body hydrated.`,
                `The plating method suggests pairing a glass of milk with your meal, but water is also a perfectly acceptable choice when dining out somewhere.`
            ]
        }
    ],
    congrats: `CONGRATULATIONS!!! You’ve demonstrated that you understand the plate method well enough to make smart choices the next time you visit an Italian style restaurant.`
}
